import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {Provider as IntlProvider, Manager as IntlManager} from 'packages/@shopify/react-i18n';
import Nav from './Nav';

export * from './Nav';

const manager = new IntlManager({locale: 'en-CA'});

function NavSection(props) {
  return (
    <IntlProvider manager={manager}>
      <Nav {...props} />
    </IntlProvider>
  );
}

export default renderReact('Nav', NavSection);
